import React from 'react';
import Field from '@gqlapp/forms-client-react/FieldAdapter';

import withProps from "recompose/withProps";
import RenderField from "@xem/look/Renders/Field";
import FieldWrap, { WrapControler } from "@gqlapp/base/FieldWrap";
import moment from 'moment';
import RenderRadiosBox from "@gqlapp/base/RenderRadiosBox";
import Row from '@gqlapp/base/Row';
import Col from '@gqlapp/base/Col';
import { FieldConfig } from "@xem/look/FieldConfig";

export default withProps(( { values:{ birthday, sex, ...values}})=>{
  let { day, month, year } = birthday || {};
  const ObjectField = {
    className: 'my-0',
    component : RenderField,
    inputProps: { inputMode: 'numeric', min: 0 },
    type: 'text',
  }
  let now     = Number(moment().format('YYYY'))
  let maxYear     = Number(moment().format('YYYY')) - 18

  let months  = ([...Array(13).keys()].slice(1)).map(value => ({value, renderLabel: 'Month' }));
  let years   =  ([...Array(now).keys()].slice(now - 200, now)).sort((a, b)=> b - a).map(value=> ++value).map(value => ({value, label: `${value}`}));

  let sexs    = [
    { value: 'male', label: 'user:profile.form.field.male'.t() },
    { value: 'female', label: 'user:profile.form.field.female'.t() },
    { value: 'other', label: 'user:profile.form.field.other'.t()}
  ];
  sex = sex || sexs.slice(sexs.length);
  return { maxYear, ObjectField, birthday: { day, month, year }, sex, values, sexs, months, years}
})
(({ setFieldValue, sex, sexs,  birthday: { day, month, year} , t }) =>  (<>
  <>
    <FieldWrap
      size={80}
      sx={{
        position: 'relative',
        paddingBottom: '15px'
      }}
    >
      <Field {...{ component: WrapControler }} name={'birthday'}>
        {({ meta:{ }})=><>
          <Row small sx={{ '.MuiFormControl-root': { minHeight: '40px' }}}>
            <Col xs={12}><label htmlFor="birthday" className={'mb-3'}>{'Ngày sinh của bạn'.t()}&nbsp;<span className={'text-secondary'}>{'norequire'.t()}</span></label></Col>
            <Col xs={4}>
              <FieldConfig
                {...{ onRemove: setFieldValue, inputProps: { tabIndex: 2, inputMode: 'numeric', min: 1, max: 31 } }}
                {...{
                  size: '40',
                  mask: [/\d/, /\d/],
                  name: 'birthday.day',
                  label:'user:profile.form.field.day'.t(),
                  value: day
                }}
              />
            </Col>
            <Col xs={4}>
              <FieldConfig
                {...{ onRemove: setFieldValue, inputProps: { tabIndex: 3, inputMode: 'numeric', min: 1, max: 31 } }}
                {...{
                  size: '40',
                  mask: [/\d/, /\d/],
                  name: 'birthday.month',
                  label: 'user:profile.form.field.month'.t(),
                  value: month
                }}
              />
            </Col>
            <Col xs={4}>
              <FieldConfig
                {...{ onRemove: setFieldValue, inputProps: { tabIndex: 4, inputMode: 'numeric', min: 1, max: 31 } }}
                {...{
                  size: '40',
                  mask: [/\d/, /\d/, /\d/,  /\d/],
                  name: 'birthday.year',
                  label: 'user:profile.form.field.year'.t(),
                  value: year
                }}
              />
            </Col>
          </Row>
        </>}
      </Field>
    </FieldWrap>
    <FieldWrap
      size={80}
      sx={{
        position: 'relative',
        paddingBottom: '15px'
      }}
    >
      <Field
        inline
        {...{ onChange: setFieldValue, inputProps: { tabIndex: 5 } }}
        {...{
          component: RenderRadiosBox,
          classNameGroup:'d-flex justify-content-between',
          name: 'sex',
          label: <span className={'text-dark'}>{'user:profile.form.field.sex'.t()}&nbsp;<span className={'text-secondary'}>{'norequire'.t()}</span></span>,
          options: sexs,
          value: sex
        }}
      />
    </FieldWrap>
  </>
</>));
